import React from 'react';
import PropTypes from 'prop-types';
import styles from './DataPoint.module.scss';

export default function DataPoint(props) {
  return (
    <div className={styles.container}>
      <p className={styles.data}>{ props.children }</p>
      <p className={styles.title}>{ props.title }</p>
    </div>
  );
}

DataPoint.propTypes = {
  children: PropTypes.any,
  title: PropTypes.string,
};
